import { render } from "./Testdmo.vue?vue&type=template&id=3f4e0981&scoped=true&ts=true"
import script from "./Testdmo.vue?vue&type=script&lang=ts"
export * from "./Testdmo.vue?vue&type=script&lang=ts"

import "./Testdmo.vue?vue&type=style&index=0&id=3f4e0981&scoped=true&lang=css"
import "./Testdmo.vue?vue&type=style&index=1&id=3f4e0981&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4e0981"]])

export default __exports__